import { ErrorBoundary } from '../error/ErrorBoundary';

export const SectionErrorBoundary = ErrorBoundary;
